<template>
    <div id="app">
        <v-app>
            <v-locale-provider>
                <AppHeader v-if="adminUser" />
                <BaseHeader v-else />
                <main class="app__main display-under-body">
                    <AppMenu v-if="adminUser" />
                    <router-view class="web-app-router-view" />
                </main>
            </v-locale-provider>
            <TheNotificationSnackbar />
        </v-app>
    </div>
</template>

<script setup lang="ts">
import BaseHeader from "@/components/core/BaseHeader.vue"
import AppHeader from "@/components/global/AppHeader.vue"
import AppMenu from "@/components/global/AppMenu.vue"
import TheNotificationSnackbar from "@/components/global/TheNotificationSnackbar.vue"
import { useAuthStore } from "./store/core/auth"
import { storeToRefs } from "pinia"

const authStore = useAuthStore()
const { adminUser } = storeToRefs(authStore)
</script>

<style lang="scss">
@use "@/styles/index" as styles;
@use "@/styles/login";

.app__main {
    height: calc(100vh - styles.$header-height);
    max-height: calc(100vh - styles.$header-height);
    width: 100vw;
    display: flex !important;
}

.web-app-router-view {
    flex: 1;
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
    scroll-behavior: smooth;
    overflow-anchor: none;
    margin: 0 auto;
}
</style>
